<template>
  <div>
    <el-descriptions
      class="margin-top"
      title="运动员管理"
      border
      :column="UI.clientWidth < 1000 ? 1 : 3"
      :labelStyle="{ width: UI.clientWidth < 1000 ? '100px' : '100px' }"
    >
      <template slot="extra">
        <el-button
          v-if="User.hasLogin"
          :disabled="
            User.organization_info.is_approved != $approveConsts.APPROVED.value
          "
          type="primary"
          @click="
            userInfoPre = {};
            isRegShow = true;
          "
        >
          {{
            User.organization_info.is_approved == $approveConsts.APPROVED.value
              ? '注册运动员'
              : '请先认证'
          }}
        </el-button>
      </template>
    </el-descriptions>

    <el-table :data="tableData" border>
      <el-table-column prop="user_id" label="ID"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>

      <el-table-column label="性别" prop="sex" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.sex == 0 ? '男' : '女' }}
        </template>
      </el-table-column>

      <el-table-column label="籍贯" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.native_place.join() }}
        </template>
      </el-table-column>

      <el-table-column
        label="民族"
        prop="nation"
        v-if="!UI.isMobile"
      ></el-table-column>

      <el-table-column label="免冠头像" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              fileUrl = scope.row.avatar;
              isShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column
        label="身份证"
        prop="identifier_code"
        v-if="!UI.isMobile"
      ></el-table-column>

      <el-table-column label="身份证扫描件" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              fileUrl = scope.row.identifier_image;
              isShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="户籍证明" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              fileUrl = scope.row.household_image;
              isShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="代表资格协议" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              fileUrl = scope.row.contract;
              isShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="协议时间" v-if="!UI.isMobile">
        <template slot-scope="scope">
          {{ scope.row.contract_start_time }} ->
          {{ scope.row.contract_end_time }}
        </template>
      </el-table-column>

      <el-table-column label="状态" v-if="!UI.isMobile">
        <template slot-scope="scope">
          <el-tag size="small" :type="approveBtn[scope.row.is_approved]">
            {{ $getApproveLabel(scope.row.is_approved) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="查看信息" v-else>
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              info = scope.row;
              isInfoShow = true;
            "
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            :disabled="scope.row.is_approved == $approveConsts.APPROVED.value"
            @click="
              userInfoPre = scope.row;
              isRegShow = true;
            "
            type="text"
          >
            修改
          </el-button>
          <el-button
            @click="
              deletePlayer(scope.row.id)
            "
            type="text"
          >
            删除
          </el-button>
          <el-button
            @click="
              userInfoPre = scope.row;
              isExchangeShow = true;
            "
            type="text"
          >
            交流
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total == 1"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isInfoShow"
      width="98%"
      v-if="UI.isMobile"
    >
      <div class="padding-xs">
        <el-descriptions :column="1" border>
          <el-descriptions-item
            v-for="(value, key) in info"
            :key="key"
            :label="key"
          >
            <div v-if="!(value + '').startsWith('http')">{{ value }}</div>
            <div v-else>
              <el-button
                type="text"
                @click="
                  fileUrl = value;
                  isShow = true;
                "
              >
                点击查看
              </el-button>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isShow"
      width="800px"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="注册"
      v-if="isRegShow"
      :visible.sync="isRegShow"
      width="800px"
    >
      <UserInfoEdit
        @success="onSuccess"
        :userInfoPre="userInfoPre"
      ></UserInfoEdit>
    </el-dialog>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="注册"
      v-if="isExchangeShow"
      :visible.sync="isExchangeShow"
      width="800px"
    >
      <ExchangeEdit
        @success="onSuccess"
        :exchangeData="userInfoPre"
      ></ExchangeEdit>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getPlayers, deletePlayer } from '@/servers/org.js';
import UserInfoEdit from './userInfoEdit.vue';
import ExchangeEdit from './exchangeEdit.vue';

export default {
  components: {
    UserInfoEdit,
    ExchangeEdit,
  },

  data() {
    return {
      userInfoPre: {},
      isRegShow: false,
      info: {},
      isInfoShow: false,
      isExchangeShow: false,
      isShow: false,
      fileUrl: '',
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  computed: {
    ...mapState(['UI', 'User']),
  },

  created() {
    this.flushData();
  },

  methods: {
    onSuccess: function() {
      this.isRegShow = false;
      this.isExchangeShow = false;
      this.userInfoPre = {};
      this.flushData();
    },

    flushData: function() {
      let that = this;
      getPlayers(this.filterForm, function(res) {
        that.total = res.total;
        that.tableData = [];
        res.items.forEach((item) => {
          that.tableData.push(item.user_info);
        });
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    deletePlayer: function(playerId) {
      let that = this;

      this.$alert('确认删除？', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            deletePlayer(playerId, function(res) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              });
              that.flushData();
            });
          }
        });
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/info/orgPlayerList.vue